// extracted by mini-css-extract-plugin
export default {"container":"output_container__sfS+D","label":"output_label__gwNae","text":"output_text__p8TQJ"};